export const autoplayCarouselSlidesPerView = {
  mobile: 1,
  tablet: 2,
  desktop: 3,
}
